exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdm-user-name-select[data-v-5be2df9c]{display:inline-block}\n", ""]);

// exports
